import { jwtDecode } from 'jwt-decode';

import { DecodedToken, DefaultResponse } from '../shared.types';

import { MagicLinkLoginData } from './magicLink.types';

import axiosServer from '@/services/axios';
import { useAuthStore } from '@/stores/useAuthStore';
import { useMagicLinkStore } from '@/stores/useMagicLinkStore';
import { transformToApiError } from '@/utils/error.ts';

export const sendMagicLink = async (
  reqData: MagicLinkLoginData
): Promise<DefaultResponse> => {
  try {
    const response = await axiosServer.post('/signin/magic', reqData);

    if (!response.data.success) {
      return response.data;
    }

    const { setLinkSent, setEmail } = useMagicLinkStore.getState();
    setLinkSent();
    setEmail(reqData.email);

    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const activateMagicLink = async (
  token: string
): Promise<DefaultResponse | null> => {
  try {
    const res = await axiosServer.get(`/signin/magic?token=${token}`);

    if (!res.data.success) {
      return res.data;
    }

    const apiToken = res.headers.token;
    const decoded = jwtDecode<DecodedToken>(apiToken);

    const { firstName, lastName } = res.data.content;

    const auth = useAuthStore.getState();
    auth.login(apiToken, firstName, lastName, decoded.role);

    return res.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
